import React from 'react';
import PropTypes from 'prop-types';
import BaseSelect from '../select';
import USStates from './us-states';

const State = props => {
  const { 'data-cv-test': dataCvTest } = props;

  return (
    <BaseSelect
      name="state"
      label="State"
      options={USStates}
      transparent
      disabledStateValue={{ value: 'default', label: 'State' }}
      {...props}
      data-cv-test-override={dataCvTest || 'addressState'}
    />
  );
};

State.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  error: PropTypes.string,
  'data-cv-test': PropTypes.string
};

State.defaultProps = {
  value: '',
  error: '',
  'data-cv-test': ''
};

export default State;
